import { render, staticRenderFns } from "./weatherForecast1.vue?vue&type=template&id=4dc15e87&scoped=true&"
import script from "./weatherForecast1.vue?vue&type=script&lang=js&"
export * from "./weatherForecast1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc15e87",
  null
  
)

export default component.exports